import React from "react";
import FontAwesomeIcon from "@streeteasy/design-system/deprecated/Icons/FontAwesomeIcon";
import pluralize from "pluralize";
import PropTypes from "prop-types";

import expertProps from "../../utilities/expertProps";
import * as S from "./styled";

const DealDetails = ({ expert }) =>
  expert.sales_in_area_count || expert.rentals_in_area_count ? (
    <S.DealDetails>
      <S.Title>Total Deals in NYC</S.Title>
      <S.Information>
        {expert.sales_in_area_count ? (
          <>
            <FontAwesomeIcon
              color="primary"
              desktopPadding="0"
              fontSize="14px"
              iconClass="checkmark"
            />
            <strong>{expert.sales_in_area_count}</strong>{" "}
            {pluralize("Sale", expert.sales_in_area_count)}
          </>
        ) : null}
        {expert.rentals_in_area_count ? (
          <>
            <FontAwesomeIcon
              color="primary"
              desktopPadding="0"
              fontSize="14px"
              iconClass="checkmark"
            />
            <strong>{expert.rentals_in_area_count}</strong>{" "}
            {pluralize("Rental", expert.rentals_in_area_count)}
          </>
        ) : null}
      </S.Information>
    </S.DealDetails>
  ) : null;

DealDetails.propTypes = {
  expert: PropTypes.shape(expertProps).isRequired
};

export default DealDetails;
